function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.880859 9C1.58198 5.16 4.9287 2.25 8.95043 2.25C12.9722 2.25 16.3181 5.16 17.02 9C16.3189 12.84 12.9722 15.75 8.95043 15.75C4.9287 15.75 1.58272 12.84 0.880859 9ZM8.95043 12.75C9.93951 12.75 10.8881 12.3549 11.5875 11.6517C12.2869 10.9484 12.6798 9.99456 12.6798 9C12.6798 8.00544 12.2869 7.05161 11.5875 6.34835C10.8881 5.64509 9.93951 5.25 8.95043 5.25C7.96134 5.25 7.01277 5.64509 6.31338 6.34835C5.61399 7.05161 5.22108 8.00544 5.22108 9C5.22108 9.99456 5.61399 10.9484 6.31338 11.6517C7.01277 12.3549 7.96134 12.75 8.95043 12.75ZM8.95043 11.25C8.35698 11.25 7.78783 11.0129 7.3682 10.591C6.94856 10.169 6.71282 9.59674 6.71282 9C6.71282 8.40326 6.94856 7.83097 7.3682 7.40901C7.78783 6.98705 8.35698 6.75 8.95043 6.75C9.54388 6.75 10.113 6.98705 10.5327 7.40901C10.9523 7.83097 11.188 8.40326 11.188 9C11.188 9.59674 10.9523 10.169 10.5327 10.591C10.113 11.0129 9.54388 11.25 8.95043 11.25Z",
  fill: "#1F1F1F"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.9009,
  height: 18,
  fill: "white"
})));

var SvgLook = function SvgLook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/look.8d9e708c.svg";
export { ForwardRef as ReactComponent };